import { Component, useEffect, useState, useSyncExternalStore } from 'react';
import { LoaderCircle } from 'lucide-react';
import { requestActivity } from '@/lib/requestActivity';
import './LoadingFeedback.css';

export class PageErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div role="alert" className="page-loader">
      <h2 className="text-lg font-semibold text-foreground">This page could not be opened</h2>
      <p className="max-w-md text-center text-sm">You can use the menu to open another page, or reload. Unsaved edits may be lost when reloading.</p>
      <p className="max-w-md text-center text-sm">If this happened after saving, check the saved record before repeating the action.</p>
      <button className="rounded-md border px-4 py-2 text-sm text-foreground" onClick={() => window.location.reload()}>Reload page</button>
    </div>;
  }
}

export function PageLoader({ label = 'Loading page…', fullScreen = false }) {
  return <div role="status" aria-live="polite" aria-busy="true"
    className={`page-loader ${fullScreen ? 'page-loader-full' : ''}`}>
    <LoaderCircle aria-hidden="true" className="loading-feedback-spinner h-6 w-6" />
    <span>{label}</span>
    <div className="page-loader-placeholder" aria-hidden="true"><span /><span /><span /></div>
  </div>;
}

export function RequestActivityIndicator() {
  const { count, writes } = useSyncExternalStore(requestActivity.subscribe, requestActivity.getSnapshot, requestActivity.getSnapshot);
  const active = count > 0;
  const [visible, setVisible] = useState(false);
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!active) { setVisible(false); setSlow(false); return; }
    const show = setTimeout(() => setVisible(true), 180);
    const long = setTimeout(() => setSlow(true), 10000);
    return () => { clearTimeout(show); clearTimeout(long); };
  }, [active]);
  if (!active || !visible) return null;
  return <div className="request-activity" role="status" aria-live="polite" aria-atomic="true">
    <LoaderCircle aria-hidden="true" className="loading-feedback-spinner h-4 w-4" />
    <span>{slow ? 'Still working…' : writes ? 'Processing request…' : 'Loading data…'}</span>
  </div>;
}
